// extracted by mini-css-extract-plugin
module.exports = {"gameFIB001":"FillTheBlank_gameFIB001__7l4I7","text":"FillTheBlank_text__20zwE"};